<template>
  <div class="goals-container w-full h-full mx-auto p-4 bg-white shadow rounded">
    <LoadingOverlay :visible="isLoading" text="Guardando..." spinnerClass="text-blue-500" textClass="text-green-300" />
    <h5 class="text-2xl mb-6">Agregar Evaluación de objetivos para : <b>{{ user.name }} {{ user.last_name }} </b></h5>
    <hr class="mb-4" />

    <div class="goals-list mb-6">
      <button
        @click="addGoal"
        class="btn-success text-white px-4 py-2 rounded hover:bg-green-600 mb-2"
      >
        Agregar Meta
      </button>

      <div
        v-for="(goal, index) in goals"
        :key="index"
        class="goal-item flex flex-col mb-3 p-3 border rounded"
      >
        <div class="d-flex flex-wrap gap-2 items-center" style="width: 100%;">
          <div class="text-sm text-gray-700" style="width: 70%;">Objetivo</div>
          <div class="text-sm text-gray-700" style="width: 10%;">% de Meta</div>
        </div>
        <div class="flex flex-wrap gap-2 items-center">
          <input
            v-model="goal.name"
            @input="validateGoal(goal)"
            type="text"
            class="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none flex-grow " style="width: 70%;"
            placeholder="Agrega el objetivo"
          />

          <input
            v-model.number="goal.percentage"
            type="number"
            min="0"
            max="100"
            class="w-1/5 p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none" style="width: 10%;"
            @input="validatePercentage"
            placeholder="%"
          />

          <button
            v-if="goals.length > 5"
            @click="removeGoal(index)"
            class="ml-2 btn-danger px-1 py-2 rounded text-white"
          >
            Eliminar
          </button>
        </div>

        <span v-if="goal.error" class="text-red-500 text-sm mt-1">
          {{ goal.error }}
        </span>
      </div>
    </div>

    <div class="text-right text-sm text-gray-700 mb-3">
      Total porcentaje asignado: <b>{{ totalPercentage }}%</b>
      <span v-if="totalPercentage !== 100" class="text-red-500"> (debe ser 100%)</span>
    </div>

    <div class="flex justify-between items-center">
      <button
        @click="submitGoals"
        :disabled="!canSubmit"
        class="btn-success text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        Guardar Metas
      </button>
    </div>
  </div>
</template>

<script>
import request from '../../services/request'
import LoadingOverlay from '../../component/GlobalLoad.vue';
import { mapActions } from 'vuex';

export default {
  components: { LoadingOverlay },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  name: "manager-goals",
  data() {
    return {
      goals: Array(5).fill(null).map(() => ({
        name: "",
        percentage: 0,
        valid: false,
        error: null
      })),
      isLoading: false,
    };
  },
  computed: {
    totalPercentage() {
      return this.goals.reduce((sum, goal) => sum + Number(goal.percentage || 0), 0);
    },
    canSubmit() {
      return (
        this.goals.length >= 5 &&
        this.totalPercentage === 100 &&
        this.goals.every((goal) => goal.valid)
      );
    },
  },
  methods: {
    addGoal() {
      this.goals.push({ name: "", percentage: 0, valid: false, error: null });
    },
    removeGoal(index) {
      if (this.goals.length > 5) {
        this.goals.splice(index, 1);
      }
    },
    validateGoal(goal) {
      if (!goal.name.trim()) {
        goal.error = "La meta es requerida.";
        goal.valid = false;
      } else if (goal.name.length < 20) {
        goal.error = "La meta debe tener al menos 20 caracteres.";
        goal.valid = false;
      } else if (goal.percentage < 0 || goal.percentage > 100) {
        goal.error = "El porcentaje debe estar entre 0 y 100.";
        goal.valid = false;
      } else {
        goal.error = null;
        goal.valid = true;
      }
    },
    validatePercentage() {
      this.goals.forEach(goal => this.validateGoal(goal));
    },
    async submitGoals() {
      const payload = this.goals.map((goal) => ({
        name: goal.name.trim(),
        percentage: Number(goal.percentage),
      }));

      this.isLoading = true;

      try {
        const { data } = await request.post("/evaluations/scope-evaluation", {
          user_id: this.user.id,
          goals: payload,
        });
        console.log(data);

        this.successNotification("Metas guardadas exitosamente.");
        this.$router.push({ path: '/evaluations/manager-evaluations' });

      } catch (error) {
        this.errorNotification("Hubo un error al guardar las metas. Por favor, inténtelo de nuevo.");
      } finally {
        this.isLoading = false;
      }
    },
    ...mapActions({
      successNotification: 'alert/success',
      errorNotification: 'alert/error',
    }),
  }
};
</script>

<style scoped>
.goals-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
}
.goal-item {
  background: #f9f9f9;
}
button {
  transition: all 0.2s ease-in-out;
}
button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
button:hover:not(:disabled) {
  transform: translateY(-2px);
}
</style>
